"use client"

import Image, { StaticImageData } from "next/image"
import Link from "next/link"
import { usePathname, useRouter } from "next/navigation"
import { cn } from "@heroui/react"

import favorites_icon from "@/assets/menu/favorites.png"
import invite_friends_icon from "@/assets/menu/invite-friends.png"
import recents_icon from "@/assets/menu/recents.png"
import trending_snaps_icon from "@/assets/menu/trending-snaps.png"

export const LinkItem = ({
  href,
  title,
  icon,
  className,
}: {
  href: string
  title: string
  icon?: StaticImageData
  className?: string
}) => {
  const pathname = usePathname()
  const router = useRouter()

  const isActive = pathname === href

  return (
    <Link
      href={href}
      className={cn(
        "text-primary flex h-9 items-center gap-2 rounded-lg p-2 hover:opacity-70",
        isActive ? "bg-black/5" : "grayscale",
        className
      )}
      onClick={(e) => {
        if (isActive) {
          e.preventDefault()
          e.stopPropagation()
          router.replace(href + "?t=" + Date.now(), {
            scroll: true,
          })
        }
      }}
    >
      {icon && (
        <Image src={icon} alt={title} unoptimized priority className="size-5" />
      )}
      <span className="text-sm font-medium">{title}</span>
    </Link>
  )
}

export const LinkItemNew = ({
  href,
  title,
  icon,
  className,
}: {
  href: string
  title: string
  icon?: StaticImageData
  className?: string
}) => {
  const pathname = usePathname()
  const router = useRouter()

  const isActive = pathname === href

  return (
    <Link
      href={href}
      className={cn(
        "text-primary flex h-9 items-center gap-2 rounded-lg p-2 hover:opacity-70",
        isActive ? "text-[#0f9e4f]" : "grayscale",
        className
      )}
      onClick={(e) => {
        if (isActive) {
          e.preventDefault()
          e.stopPropagation()
          router.replace(href + "?t=" + Date.now(), {
            scroll: true,
          })
        }
      }}
    >
      {icon && (
        <Image src={icon} alt={title} unoptimized priority className="size-5" />
      )}
      <span
        className={cn(
          isActive
            ? "text-[14px] text-[#0f9e4f]"
            : "text-[14px] text-[#4E5969]",
          "font-medium"
        )}
      >
        {title}
      </span>
    </Link>
  )
}

export function MenuBar() {
  return (
    <div className="flex flex-col gap-2 pt-2">
      <LinkItem href="/recents" title="Recents" icon={recents_icon} />
      <LinkItem href="/favorites" title="Favorites" icon={favorites_icon} />
      <LinkItem
        href="/trending-snaps"
        title="Trending Snaps"
        icon={trending_snaps_icon}
      />
      <LinkItem href="/rewards" title="rewards" icon={invite_friends_icon} />
    </div>
  )
}

export function TopMenuBar() {
  return (
    <div className="hidden flex-row gap-8 sm:flex">
      <LinkItem href="/recents" title="Recents" className="text-foreground" />
      <LinkItem
        href="/favorites"
        title="Favorites"
        className="text-foreground"
      />
      <LinkItem
        href="/trending-snaps"
        title="Trending Snaps"
        className="text-foreground"
      />
    </div>
  )
}

export function TopMenuBarNew() {
  return (
    <div className="hidden flex-row gap-5 sm:flex">
      <LinkItem href="/" title="Home" className="text-foreground" />
      <LinkItem
        href="/favorites"
        title="Favorites"
        className="text-foreground"
      />
      <LinkItem href="/recents" title="Recents" className="text-foreground" />
      <LinkItem href="/rewards" title="Rewards" className="text-foreground" />
    </div>
  )
}
